import { Box, Flex, Typography, Confirmation } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React, { useState } from "react"
import { Link } from "react-router-dom"
import styled from "styled-components"

import withCollection from "areas/collection/hoc/with-collection"
import LoadMoreProducts from "areas/collection/load-more-products"

import CollectionAd from "./collection-ad"
import CollectionProduct from "./collection-product"
import Placeholder from "./placeholder"

const Container = styled(Flex)`
  flex-wrap: wrap;
  margin-bottom: 35px;
  padding: 0 10px;
  ${({ theme }) => theme.mediaQueries.tablet`
    padding: 0;
  `}
`

const Wrapper = styled.div`
  font-size: 20px;
  margin: 2em 0;
  text-align: center;
  ul {
    list-style: none;
    li {
      a {
        text-decoration: underline !important;
      }
    }
  }
`
const genericSearchFail = (
  <Container data-cy="collection-not-result" justifyContent="center">
    <Typography fontSize="20px" my="2em" textAlign="center">
      Sorry, we could not find any results for your search. Please try a
      different search term, or you can trying searching our{" "}
      <Link data-lc="collection-main" to="/helpdesk">
        knowledge base
      </Link>
    </Typography>
  </Container>
)

const InternalCollectionMain = ({
  addToWishlist,
  confirmAddToWishlist,
  currentPage,
  gridView,
  no_result_message,
  placeholders,
  products,
  showLoading,
  toggleFinishAddToWishlist,
  totalPage,
}) => {
  let placeholderSwitch = placeholders
  let productSwitch = products

  if (productSwitch && productSwitch.length < 1 && !showLoading) {
    if (no_result_message && no_result_message != "") {
      try {
        no_result_message = no_result_message.replace(/href="#"/g, "")
        no_result_message = no_result_message.replace(
          /ea_seopatch="-/g,
          // eslint-disable-next-line quotes
          'href="/search?k='
        )

        let parser = new DOMParser()
        let el = parser.parseFromString(no_result_message, "text/html")

        let links = []
        Array.from(el.querySelectorAll("a")).map((a) => {
          let to = a.getAttribute("href")
          let text = a.innerText
          links.push({ text, to })
        })

        const messages = {
          links,
          title: `${no_result_message.split(":")[0]}:`,
        }

        return (
          <Container justifyContent="center">
            <Wrapper>
              <Typography fontSize="1.3rem">{messages.title}</Typography>
              <ul>
                {messages.links.map((link) => (
                  <li key={link.text}>
                    <Link data-lc="collection-main" to={link.to}>
                      {link.text}
                    </Link>
                  </li>
                ))}
              </ul>
            </Wrapper>
          </Container>
        )
      } catch (err) {
        console.log("Search parsing error: ", err)
        return genericSearchFail
      }
    } else {
      return genericSearchFail
    }
  }

  const [showWishlistDialog, setShowWishlistDialog] = useState(false)
  const [productParams, setProductParams] = useState(false)
  let adCounter = 0
  let productsOut = []
  if (productSwitch) {
    productSwitch.forEach((product, index) => {
      if (product && product.item_type == "product") {
        const nextProduct = products[index + 1]
        if (
          nextProduct &&
          nextProduct.item_type == "ad_block" &&
          nextProduct.ad_size > 1 &&
          (adCounter % 2 == 0 || adCounter % 3 == 1)
        ) {
          productsOut.push(
            <CollectionAd
              ad={nextProduct}
              counter={adCounter}
              index={index}
              key={`ad-before-product-${product.style_code}-${index}`}
              position="before"
            />
          )
        }
        productsOut.push(
          <CollectionProduct
            confirmWishlist={setShowWishlistDialog}
            index={index}
            key={`product-${product.style_code}-${index}`}
            product={product}
            setProductParams={setProductParams}
          />
        )
        if (nextProduct && nextProduct.item_type == "ad_block") {
          productsOut.push(
            <CollectionAd
              ad={nextProduct}
              counter={adCounter}
              index={index}
              key={`ad-after-product-${product.style_code}-${index}`}
              position="after"
            />
          )
          // Increase the ad counter by the ad size
          adCounter += nextProduct.ad_size
        }
        // Increase the ad counter for the product placement
        adCounter++
      }
    })
  }

  return (
    <Container data-cy="collection-main-products">
      {[...Array(placeholderSwitch)].map((_, i) => (
        <Placeholder gridView={gridView} index={i} key={`placeholder-${i}`} />
      ))}
      {productsOut}
      <Box data-cy="collection-load-product" width={"100%"}>
        {currentPage < totalPage && <LoadMoreProducts next={currentPage + 1} />}
      </Box>
      <Confirmation
        cancelText="Cancel"
        confirmText="Proceed"
        description="You have reached the maximum number of items in your wish list. If you add this item now, your oldest item will be removed."
        onCancel={() => {
          confirmAddToWishlist(false)
          setShowWishlistDialog(false)
          toggleFinishAddToWishlist()
        }}
        onConfirm={() => {
          confirmAddToWishlist(true)
          setShowWishlistDialog(false)
          addToWishlist(productParams)
        }}
        show={showWishlistDialog}
        title="Add to Wishlist"
      />
    </Container>
  )
}

InternalCollectionMain.propTypes = {
  addToWishlist: PropTypes.func,
  confirmAddToWishlist: PropTypes.func,
  currentPage: PropTypes.number,
  data: PropTypes.object,
  gridView: PropTypes.string,
  message: PropTypes.string,
  no_result_message: PropTypes.string,
  placeholders: PropTypes.number,
  products: PropTypes.array,
  showLoading: PropTypes.oneOf(["content", "full"]),
  toggleFinishAddToWishlist: PropTypes.func,
  totalPage: PropTypes.number,
}

const CollectionMain = withCollection(InternalCollectionMain)

export default CollectionMain
